import React from "react";
import { WizTableForm } from '@/containers/common'
const offlineProgram = WizTableForm.Config.offlineProgram(this, {apiParams: {}});

//配置项
const componentName = "offlineProgramReport";

function columns() {
  return [
    {
      title: "主题名称",
      name: "name",
      tableItem: {},
    },
    {
      title: "主题名称",
      name: "offlineProgramIds",
      searchItem: {
        ...offlineProgram,
        diy: WizTableForm,
        rules: [
          {
            required: true,
            message: '请选择主题名称'
          }
        ]
      },
    },
    {
      title: "主题编号",
      name: "code",
      tableItem: {},
    },
    {
      title: "主题分类名称",
      name: "programCategoryName",
      tableItem: {},
    },
    {
      title: "总人数",
      name: "times",
      tableItem: {},
    },
    {
      title: "参训人数",
      name: "factCount",
      tableItem: {},
    },
    {
      title: "参训率",
      name: "trainingRate",
      tableItem: {
        render: text => text + '%'
      },
    },
    {
      title: "通过人数",
      name: "passCount",
      tableItem: {},
    },
    {
      title: "通过率",
      name: "passRate",
      tableItem: {
        render: text => text + '%'
      },
    },
  ];
}

function templateConfig() {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns.call(this),
        searchBarProps: {
          collapse: false,
          buttonSort:['export'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams:(rows,record,filters,callback)=>{
                  return {...filters}
                }
              }
            }
          ]
        },
        dataTableProps: {
          rowKey: (record, index) => index,
          isScroll: true,
          loading: false,
        }
      },
    },
  };
}

const apis = {
  list: {
    path: `${componentName}/getPageListProgram`,
    payload: {
      key: `${componentName}@getPageListProgram`,
      apiParams: { pageNum: 1, pageSize: 10 },
    },
  },
  export: {
    path: `${componentName}/exportProgram`,
    payload: {
      key: `${componentName}@exportProgram`,
      apiParams: {}
    }
  },
};

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    ...args,
  };
};

export { reduxTemplateCofig, templateConfig };
